import React from 'react'
import {Skeleton} from 'primereact/skeleton'

export default function DatatableSkeleton() {
  return (
    <div className='container d-flex col gap-4'>
      <Skeleton width='25%' height='1.3rem' />
      <Skeleton width='25%' height='1.3rem' />
      <Skeleton width='25%' height='1.3rem' />
      <Skeleton width='25%' height='1.3rem' />
    </div>
  )
}
